import PaginationBar from './PaginationBar';

export default PaginationBar;
